import { useLang } from "@/context/LanguageContext";
import { AlertCircle, CheckCircle } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Receiving differences for one tenant's work; `actions(row)` lets each screen add its own controls.
export default function DiscrepancyList({ rows, names = {}, actions }) {
  const { t } = useLang();
  return (
    <div className="space-y-2">
      {rows.map(row => {
        const open = row.status === "OPEN";
        return (
          <div key={row.id} className={`rounded-xl border p-3 ${open ? "bg-amber-50 border-amber-200" : "bg-slate-50 border-slate-200"}`}
            data-testid={`discrepancy-${row.id}`}>
            <div className="flex items-start justify-between gap-2 flex-wrap">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-slate-800 truncate">{names[row.asin] || row.asin}</p>
                <p className="text-[11px] font-mono text-slate-500">{row.asin}</p>
              </div>
              <div className="flex items-center gap-1.5 flex-wrap justify-end">
                {row.types.map(type => (
                  <span key={type} className="rounded-full border border-amber-300 bg-white px-2 py-0.5 text-[11px] font-semibold text-amber-700">
                    {t(`disc.type.${type}`)}
                  </span>
                ))}
                <span className={`flex items-center gap-1 text-[11px] font-semibold ${open ? "text-amber-700" : "text-emerald-700"}`}>
                  {open ? <AlertCircle className="w-3 h-3" /> : <CheckCircle className="w-3 h-3" />}
                  {t(`disc.status.${row.status}`)}
                </span>
              </div>
            </div>
            <p className="mt-2 text-xs text-slate-600">
              {t("disc.declared")} {row.declared} · {t("disc.good")} {row.good} · {t("disc.damaged")} {row.damaged}
              {row.missing > 0 && <> · {t("disc.missing")} {row.missing}</>}
              {row.extra > 0 && <> · {t("disc.extra")} {row.extra}</>}
              {!open && row.accepted_extra > 0 && <> · {t("disc.accepted", { count: row.accepted_extra })}</>}
            </p>
            {row.note && <p className="mt-1 text-sm text-slate-700">{row.note}</p>}
            {row.photo_paths?.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-2" aria-label={t("disc.photos")}>
                {row.photo_paths.map(url => (
                  <a key={url} href={`${BACKEND}${url}`} target="_blank" rel="noreferrer">
                    <img src={`${BACKEND}${url}`} alt={t("disc.photos")} className="h-14 w-14 rounded-lg border border-slate-200 object-cover" />
                  </a>
                ))}
              </div>
            )}
            {actions && <div className="mt-2">{actions(row)}</div>}
          </div>
        );
      })}
    </div>
  );
}
